// material
// components
import ProjectPeopleList from './list';
// ----------------------------------------------------------------------
export default function UserManagement(project) {
    return <ProjectPeopleList project={project.project} />
}
